import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TextAreaV2 } from "../../../textareaV2";
export var ComboboxTextArea = withFocusToggleClassName(styled(TextAreaV2)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    width: 100%;\n    border: none;\n\n    // Override some UA styles.\n    font-family: inherit;\n    font-size: ", ";\n\n    &:focus-within::before {\n        border: none;\n        box-shadow: none;\n    }\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return menuTheme.fontSize(themeMode);
}));
//# sourceMappingURL=ComboBoxTextArea.js.map